import { ApiObterPatios } from '@/api'
import { defineStore } from 'pinia'

export const Patios = defineStore('Patios', {
   state: () => ({
      patios: null
   }),
   actions: {
      async ActionObterPatios(filtros) {
         await ApiObterPatios(filtros).then((resposta) => (this.patios = resposta))
      }
   }
})
